export const colors = {
  primary: "#FF0303",
};
